import * as React from 'react';
import { MorePage } from './model';
import { MorePageView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { NavbarTab } from 'portcall/navbar/view';
import { IRoute } from 'lib/componentRouter';

export const MorePageRoute = (morePage : MorePage, appWrapper : AppWrapper) : IRoute => ({
    view:
        <AppWrapperView model={appWrapper} navbarTab={NavbarTab.More}>
            <MorePageView model={morePage} />
        </AppWrapperView>
});


// WEBPACK FOOTER //
// ./apps/portcall/morepage/route.tsx